import __base_store from '@/store/__base_store'

/**
 * Store de títulos.
 */
export default __base_store({
	state: {
		model_name: 'title',
		per_page: 25,
	},
})

